import { Modal } from "react-bootstrap";
import React , {useEffect} from 'react'
import { useState } from 'react'
import { getSupermarketProductListApi, removeProductPostApi } from '../../../Api/PanelAdminServices'
import Button from '../../Button/Button'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import SuperyProductTable from '../../Tables/SuperyProductTable/SuperyProductTable'
import { errorToast, succToast } from "../../../Utils/Toast/Toast";

const SuperyProductsContainer = () => {
  const[products,setProducts]=useState([])
  const[rawInfo,setRawInfo]=useState([])
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    getProductList()
  }, [])

  const getProductList=async()=>{
    getSupermarketProductListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setProducts(res.products)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }
  const showModal =(info,id) => {
    if (id === 1) {
      window.open(`/editproduct/${info.key}`);
      // history.push(`/editproduct/${info.key}`,{data:info.key})
    }
    ////Delete/////
    if (id === 2) {
      setDeleteVisible(true);
      setRawInfo(info)
      
    }
    
  }
  const data =products&&products.map(item=>{
    return({
      key: item.id,
      productName:item.name, 
      barcode1:item.barcode_1,
      barcode2:item.barcode_2,
      brand:item.brand_persian,
      category:item.category_persian,
      new:item.new,
    })
  })
  const removeProduct=()=>{
    setDisable(true)
    let info={
      id:rawInfo.key
    }
    removeProductPostApi(info,res=>{
      if(res.status===1){
        succToast(res.message)
        setDisable(false)
      }else{
        errorToast(res.message)
        setDisable(false)
      }
    })
    setDeleteVisible(false);
    getProductList()
  }

  const handleOk = () => {
    setDeleteVisible(false);
  };
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };
  return (
    <div>
      <Modal show={deleteVisible} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از حذف کردن محصول مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOk}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={removeProduct}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>
      <TableFixedPage title="لیست محصولات فروشگاهی" />
      <SuperyProductTable data={data} showModal={showModal}/> 
    </div>
  )
}

export default SuperyProductsContainer